module.exports = __webpack_public_path__ + "media/images/newsletter-sidebar-bg-7ad785050f27d840a14461d4569098a5.svg";